// src/components/AppHeader.js
import React, { useState } from "react";
import { Layout, Menu, Modal, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  UploadOutlined,
  FileTextOutlined,
  LogoutOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { Sider } = Layout;

const Header = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showLogoutConfirm = () => {
    setIsModalVisible(true);
  };

  const handleConfirmLogout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/logout`,
        {},
        { withCredentials: true }
      );
      notification.success({
        message: "Logout erfolgreich",
        description: "Du wurdest abgemeldet.",
        placement: "topRight",
      });
      navigate("/login");
    } catch (error) {
      notification.error({
        message: "Logout fehlgeschlagen",
        description:
          error.response?.data?.message ||
          "Beim Logout ist ein Fehler aufgetreten.",
        placement: "topRight",
      });
    } finally {
      setIsModalVisible(false);
    }
  };

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="lg"
        collapsedWidth="80"
        width="230"
      >
        <div
          className="logo"
          style={{
            height: 32,
            margin: 16,
            textAlign: "center",
          }}
        >
          <img
            src={
              collapsed
                ? require("../certsweep-small.png")
                : require("../certsweep.png")
            }
            alt="Logo"
            style={{ height: "100%", width: "auto" }}
          />
        </div>

        <Menu theme="dark" mode="inline" defaultSelectedKeys={["dashboard"]}>
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <Link to="/">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="generator" icon={<FileTextOutlined />}>
            <Link to="/generator">Dokumenten-Generator</Link>
          </Menu.Item>
          <Menu.Item key="files" icon={<UploadOutlined />}>
            <Link to="/files">ZIP-Dateien</Link>
          </Menu.Item>
          <Menu.Item key="companies" icon={<UsergroupAddOutlined />}>
            <Link to="/companies">Firmendaten</Link>
          </Menu.Item>

          {/* Logout mit Custom Style */}
          <Menu.Item
            key="logout"
            icon={<LogoutOutlined />}
            onClick={showLogoutConfirm}
            style={{
              border: "1px solid #8B0000", // dunkelrot
              color: "#ff4d4f",
              marginTop: 20,
              borderRadius: 4,
              fontWeight: "bold",
            }}
          >
            Ausloggen
          </Menu.Item>
        </Menu>
      </Sider>

      {/* Bestätigungs-Modal */}
      <Modal
        title="Logout bestätigen"
        open={isModalVisible}
        onOk={handleConfirmLogout}
        onCancel={() => setIsModalVisible(false)}
        okText="Ja, ausloggen"
        cancelText="Abbrechen"
        okButtonProps={{ danger: true }}
      >
        <p>Bist du sicher, dass du dich ausloggen möchtest?</p>
      </Modal>
    </>
  );
};

export default Header;
